import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CommonService } from "../../services/common.service";

export interface FinanceComparitorDialogData {
  projectId?: string;
  portfolioId?: string;
  subportfolioId?: string;
  programId?: string;
  vendorId?: string;
  projectName?: string;
  portfolioName?: string;
  subportfolioName?: string;
  programName?: string;
  vendorName?: string;
  tagIds?: string[];
}

@Component({
  selector: "app-finance-comparitor-dialog",
  templateUrl: "./finance-comparitor-dialog.component.html",
  styleUrls: ["./finance-comparitor-dialog.component.scss"],
})
export class FinanceComparitorDialogComponent implements OnInit {
  displayLabels: any = {};
  breadCrumbData: string[] = [];
  constructor(
    public dialogRef: MatDialogRef<FinanceComparitorDialogComponent>,
    private readonly commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: FinanceComparitorDialogData
  ) {}

  ngOnInit(): void {
    this.breadCrumbData = [];
    this.displayLabels = this.commonService.getLabels();
    this.breadCrumbData.push("Finance Comparator");
    // You can log/inspect the incoming data here
    if (this.data.projectName) {
      this.breadCrumbData.push(this.displayLabels?.project, this.data.projectName);
    } else if (this.data.programName) {
      this.breadCrumbData.push(
        this.displayLabels?.program ?? "Program",
        this.data.programName
      );
    } else if (this.data.subportfolioName) {
      this.breadCrumbData.push(
        this.displayLabels?.sub_portfolio ?? "Sub Portfolio",
        this.data.subportfolioName
      );
    } else if (this.data.portfolioName) {
      this.breadCrumbData.push(
        this.displayLabels?.portfolio ?? "Portfolio",
        this.data.portfolioName
      );
    } else {
      this.breadCrumbData.push(this.displayLabels?.all_of_it);
    }
    if (this.data.vendorName) {
      this.breadCrumbData.push("OU/GDP", this.data.vendorName);
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
